import { addAbsolutePosition } from "instantsearch.js/es/lib/utils";
import type { GraphDataObjectV2 } from "../../historical-charts/data/data-object/graph";
import { type IPieChartDO, type StablecoinLatestDO } from "../../models/pie-chart.models";

interface PieDO {
    [key: string]: number
}


class PieChartTransform {
    public jurisdictionMarketCapsToPieDO(data: StablecoinLatestDO): PieDO {
        return data.jurisdiction_market_caps || {};
    }

    public domiciliationMarketCapsToPieDO(data: StablecoinLatestDO): PieDO {
        return data.domiciliation_market_caps || {};
    }

    public stablecoinsSupplyBySectorToPieDO(data: StablecoinLatestDO): PieDO {
        return data.stablecoins_supply_by_sector || {};
    }

    public stablecoinMarketValuePerPeggedAssetToPieDO(data: StablecoinLatestDO): PieDO {
        return data.stablecoin_market_value_per_pegged_asset || {};
    }
    public btcHashrateByCountryToPieDO(data: IPieChartDO): PieDO {
        return data;
    }

    public btcMiningEnergySourceToPieDO(data: IPieChartDO): PieDO {
        console.log(data);
        return data;
    }

    public defaultPieChartTransform(data: GraphDataObjectV2): PieDO {
        console.log(data);
        const transformedData = {} as PieDO;
        const key = Object.keys(data.data)[0];
        data.series.forEach((item, i) => transformedData[item] = data.data[key][i][0]);
        return transformedData;
    }
}

// TODO: Make it injectable only
export const pieChartTransform = new PieChartTransform()